import { Check, RefreshCw } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const perks = [
  "Content & text updates",
  "Photo and page changes",
  "Security & software updates",
  "Fixes whenever something breaks",
  "Regular check-ups to keep things running",
  "A direct line to me — no ticket queues",
];

export const Maintenance = () => (
  <section id="maintenance" className="mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-40">
    <Reveal>
      <div data-testid="maintenance-section" className="relative overflow-hidden rounded-[2rem] border border-blue-500/20 bg-gradient-to-br from-[#0A1128] via-[#0B1a3d] to-[#030712] p-8 sm:p-14 lg:p-20">
        <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-blue-600/20 blur-[120px]" />
        <RefreshCw className="spin-slow pointer-events-none absolute -bottom-16 -right-16 h-72 w-72 text-blue-500/10" strokeWidth={0.6} />
        <div className="relative grid gap-12 lg:grid-cols-2">
          <div>
            <Eyebrow>03 — Monthly maintenance</Eyebrow>
            <h2 className="font-display text-4xl font-medium leading-[1.05] tracking-tight text-white sm:text-5xl">
              Launch it. <span className="italic font-light text-gradient">Forget about it.</span>
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-slate-300">
              Want me to take care of your website after it's live? I offer monthly maintenance as an optional subscription — I handle the upkeep so you can focus on running your business.
            </p>
            <p className="mt-6 inline-flex rounded-full border border-sky-400/30 px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] text-sky-200">
              Optional · Monthly subscription
            </p>
          </div>
          <ul className="space-y-1 self-center">
            {perks.map((p, i) => (
              <Reveal key={p} delay={0.1 + i * 0.06}>
                <li className="flex items-center gap-4 border-b border-white/10 py-4 text-slate-100">
                  <Check className="h-4 w-4 shrink-0 text-sky-300" /> {p}
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </Reveal>
  </section>
);
